import type { NavigationRouter } from "@app/navigation";
import type { QueryClient } from "@tanstack/react-query";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "../app";

type Options = {
  nonce: string;
  queryClient: QueryClient;
  router: NavigationRouter;
};

export const renderApp = async ({ nonce, queryClient, router }: Options) => {
  const rootElement = document.getElementById("root");

  if (rootElement === null) {
    throw new Error(
      "Cannot render app. Please check your entrypoint (index.html)",
    );
  }

  const appRoot = createRoot(rootElement);

  appRoot.render(
    <StrictMode>
      <App nonce={nonce} queryClient={queryClient} router={router} />
    </StrictMode>,
  );
};
